import Image from "next/image";
import React from "react";

interface PreloadProps {
  className?: string;
}

const Preload = ({ className }: PreloadProps) => {
  return (
    <div className={`w-full min-h-[90dvh] flex justify-center items-center relative top-0 left-0 z-[999] transition-all animate-in fade-in-0 duration-300  ${className} `}>
      <Image
        src="/images/logo/preload.gif"
        alt="Preload"
        width={200}
        height={200}
        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
        priority
      />
    </div>
  );
};

export default Preload;
